import { Card, Flex } from "antd";
import "./styles.css";
import clsx from "clsx";

export const TitleCardsList = ({ options, value, onChange }) => {
  return (
    <Flex wrap >
      {options.map((option) => {
        return (
          <SmallTitleCard
            key={option.value}
            label={option.label}
            value={option.value}
            selectedValue={value}
            onChange={onChange}
          />
        );
      })}
    </Flex>
  );
};

export const SmallTitleCard = ({ label, value, selectedValue, onChange }) => {
  return (
    <Card
      className={clsx(
        "selectable-title-card",
        value === selectedValue && "selectable-title-card-selected"
      )}
      hoverable
      onClick={() => onChange(value)}
    >
      <p className="selectable-title-card-title">{label}</p>
    </Card>
  );
};
